(async () => {
  if (!customElements.get('before-after')) {
    class BeforeAfter extends HTMLElement {
      constructor() {
        super();

        this.image2 = this.querySelector('.second-image');
        this.control = this.querySelector('.divider-control');

        this.boundDrag = this.drag.bind(this);

        this.control.addEventListener('pointerdown', (event) => this.handleDrag(event));
        this.control.addEventListener('touchstart', (event) => this.handleDrag(event));

        document.addEventListener('pointerup', () => this.stopDrag());
        document.addEventListener('touchend', () => this.stopDrag());
      }

      handleDrag(event) {
        event.preventDefault();

        if (event.type === 'pointerdown') {
          document.addEventListener('pointermove', this.boundDrag);
        } else if (event.type === 'touchstart') {
          document.addEventListener('touchmove', this.boundDrag);
        }
      }

      drag(event) {
        let clientX;

        if (event.type === 'pointermove') {
          clientX = event.clientX;
        } else if (event.type === 'touchmove') {
          clientX = event.touches[0].clientX;
        }

        let dividerPosition = (clientX - this.getBoundingClientRect().left) / this.offsetWidth * 100;

        if (dividerPosition < 0) {
          dividerPosition = 0;
        } else if (dividerPosition > 100) {
          dividerPosition = 100;
        }

        this.control.classList.add('dragging');
        this.control.style.setProperty('--pos', `${ (dividerPosition).toFixed(2) }%`);
        this.image2.style.setProperty('--crop', `${ (dividerPosition).toFixed(2) }%`);
      }

      stopDrag() {
        document.removeEventListener('pointermove', this.boundDrag);
        document.removeEventListener('touchmove', this.boundDrag);
        this.control.classList.remove('dragging');
      }
    }

    customElements.define('before-after', BeforeAfter);
  }
})();